import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../../widgets/form/InputSelectSF'

const AddendumModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // form fields
  addendum, onAddendumChange, addendumError, setAddendumError, booleanList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update addendum'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputSelectSF type='select' name='addendum' required={true} label='Addendum'
      value={addendum} optionList={booleanList}
      onChange={onAddendumChange} error={addendumError} setError={setAddendumError}
    />

  </ModalFormUI>

export default AddendumModalUI
